import React from "react";
import { Form, Icon, Input, Checkbox, Radio, Select } from "antd";

import EmergencyElectronicText from "./Texts/EmergencyElectronicText";
import Signature from "./Signature";
import SignatureTrimmed from "./SignatureTrimmed";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

class ConsentLhsStep3aEmergency extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const props = this.props;

    const showForEmail = !(props.consentMethodType === "Email" && !props.token);
    const isEmail = props.consentMethodType === "Email";
    const isPatient = props.consentPersonType === "Patient";
    const isEmergency = props.consentPersonType === "Emergency";
    const isSurrogate = props.consentPersonType === "Surrogate";
    const isSubjectFirst = props.email_consent_signature_order === "subject_first";

    return (
      <div className="form-group">
        <h4>
          {props.signature_type === "investigator"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Investigator"
              )
            : props.consentPersonType === "Surrogate"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Surrogate"
              )
            : props.consentPersonType === "Patient"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Patient"
              )
            : props.consentPersonType === "Emergency"
            ? this.props.i18n.t(
                "NamespaceConsentLhsStep3aPatient:Consent Process - Emergency"
              )
            : ""}
        </h4>

        <div className="form-group-details">
          {props.siteID && (
            <h5>
              {this.props.i18n.t("Site ID")}: <b>{props.siteID}</b>
            </h5>
          )}
          {props.userID && (
            <h5>
              {this.props.i18n.t("User ID")}: <b>{props.userID}</b>
            </h5>
          )}
          <h5>
            {this.props.i18n.t("Subject ID")}: <b>{props.subjectID}</b>
          </h5>
        </div>

        <EmergencyElectronicText {...props} />

        <p>
          <strong>
            {this.props.i18n.t("Server Date (UTC)")}:{" "}
            {props.date || props.consentDate}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("Consent Type")}: {props.consentPersonType}
          </strong>
        </p>
        <p>
          <strong>
            {this.props.i18n.t("Consent Method")}: {props.consentMethodType}
          </strong>
        </p>
        <p>&nbsp;</p>

        <h4>
          {this.props.i18n.t(
            "NamespaceConsentLhsStep3aPatient:DOCUMENTATION OF INFORMED CONSENT"
          )}
        </h4>

        <div style={{ textAlign: "left" }}>

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:Is the deferral of consent process being utilized?')}</div>
              {props.form.getFieldDecorator('is_deferral_of_consent', {
                initialValue: props.is_deferral_of_consent,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes — complete form.')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No — Do not complete')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:1. In the opinion of the study physician who has performed a capacity assessment, the participant does not have the capacity to provide his/her own informed consent.')}</div>
              {props.form.getFieldDecorator('consent_question_study_physician_subject_no_capacity', {
                initialValue: props.consent_question_study_physician_subject_no_capacity,
                rules: [{
                  required: true,
                  message: 'Required'
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:2. In the opinion of the independent physician, who has performed a capacity assessment, the participant does not have the capacity to provide his/her own informed consent.')}</div>
              {props.form.getFieldDecorator('consent_question_independent_physician_subject_no_capacity', {
                initialValue: props.consent_question_independent_physician_subject_no_capacity,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('Required')
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:3. A Legally Authorized Representative (LAR) (i.e substitute decision maker) is not available at the time of proposed enrollment (time of baseline CT scan).')}</div>
              {props.form.getFieldDecorator('consent_question_LAR_not_available', {
                initialValue: props.consent_question_LAR_not_available,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('Required')
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:4. Available alternatives to study enrollment have been considered (including no enrollment), and enrollment in the present study is felt to be in the best interest of the participant after weighing the potential benefits')}</div>
              {props.form.getFieldDecorator('consent_question_alternatives_considered', {
                initialValue: props.consent_question_alternatives_considered,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('Required')
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:5. The investigator will continue to make reasonable efforts to locate a LAR for review of the informed consent from as soon as possible after randomization, and will reassess the participant’s capacity to consent on an ongoing basis, as outlined in the protocol.')}</div>
              {props.form.getFieldDecorator('consent_question_continue_to_locate_LAR', {
                initialValue: props.consent_question_continue_to_locate_LAR,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('Required')
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <h5 className="headline">Overall Eligibility Status</h5>
          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:Subject meets all criteria for deferral of consent')}</div>
              {props.form.getFieldDecorator('consent_question_overall_subject_meets_criteria', {
                initialValue: props.consent_question_overall_subject_meets_criteria,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('Required')
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>

          <Form.Item>
            <label>
              <div className='form-label'>{this.props.i18n.t('NamespaceConsentLhsStep3aPatient:Has this form been signed and dated (below) by both Investigator and Independent Physician?')}</div>
              {props.form.getFieldDecorator('consent_question_overall_form_signed_inv_physician', {
                initialValue: props.consent_question_overall_form_signed_inv_physician,
                rules: [{
                  required: true,
                  message: this.props.i18n.t('Required')
                }],
              })(
                <Radio.Group>
                  <Radio value={true}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:Yes')}
                  </Radio>
                  <br/>
                  <Radio value={false}>
                    {this.props.i18n.t('NamespaceConsentLhsStep3aEmergency:No')}
                  </Radio>
                </Radio.Group>
              )}
            </label>
          </Form.Item>


          <Form.Item>
            <label>
              <div className="form-label">
                {this.props.i18n.t(
                  "NamespaceConsentLhsStep3aPatient:Name of Investigator"
                )}
              </div>
              {props.form.getFieldDecorator(
                "consent_investigator_full_name",
                {
                  initialValue: props.consent_investigator_full_name,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t('Required'),
                    },
                  ],
                }
              )(
                <Input
                  disabled={props.token}
                  prefix={<Icon type="user" style={{ color: "#000" }} />}
                  placeholder={this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Name of Investigator (print)"
                  )}
                />
              )}
            </label>
          </Form.Item>

          <Signature
            fieldName="consent_investigator_signature"
            label={this.props.i18n.t(
              "NamespaceConsentLhsStep3aPatient:Signature of Investigator"
            )}
            form={props.form}
          />

          <Form.Item>
            <label>
              <div className="form-label">
                {this.props.i18n.t(
                  "NamespaceConsentLhsStep3aPatient:Name of Independent Physician"
                )}
              </div>
              {props.form.getFieldDecorator(
                "consent_physician_full_name",
                {
                  initialValue: props.consent_physician_full_name,
                  rules: [
                    {
                      required: true,
                      message: this.props.i18n.t('Required'),
                    },
                  ],
                }
              )(
                <Input
                  disabled={props.token}
                  prefix={<Icon type="user" style={{ color: "#000" }} />}
                  placeholder={this.props.i18n.t(
                    "NamespaceConsentLhsStep3aPatient:Name of Independent Physician (print)"
                  )}
                />
              )}
            </label>
          </Form.Item>

          <Signature
            fieldName="consent_physician_signature"
            label={this.props.i18n.t(
              "NamespaceConsentLhsStep3aPatient:Signature of Independent Physician"
            )}
            form={props.form}
          />

          <Form.Item>
            <label>
              <div className="form-label">
                {this.props.i18n.t(
                  "NamespaceConsentLhsStep3aPatient:Has the consent form been completed by all parties?"
                )}
              </div>
              {props.form.getFieldDecorator("consent_provided", {
                initialValue: props.consent_provided,
                rules: [
                  {
                    required: true,
                    message: this.props.i18n.t(
                      "NamespaceConsentLhsStep3aPatient:Has the consent form been completed by all parties?"
                    ),
                  },
                ],
              })(
                <Select>
                  <Option value="yes">{this.props.i18n.t("Yes")}</Option>
                  <Option value="">{this.props.i18n.t("No")}</Option>
                </Select>
              )}
            </label>
          </Form.Item>
        </div>
      </div>
    );
  }
}

export default withNamespaces()(ConsentLhsStep3aEmergency);



// WEBPACK FOOTER //
// ./src/components/ConsentTypeLhs/ConsentLhsStep3aEmergency.js